import { ETypWarrantu } from 'enums/isin/udaje/typWarrantu';

const typWarrantuSelect = [
    {
        value: ETypWarrantu.T,
        labelcz: 'ISIN_EMISE_WARRANT_TYP_T'
    },
    {
        value: ETypWarrantu.N,
        labelcz: 'ISIN_EMISE_WARRANT_TYP_N'
    },
    {
        value: ETypWarrantu.K,
        labelcz: 'ISIN_EMISE_WARRANT_TYP_K'
    }
];

export default typWarrantuSelect;
